import { ProgressBarWizard } from '@bambi/component-library/src/components/Wizard/ProgressBarWizard';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { Modal } from 'src/common/primitives/Modal';

import { useTripMenuActions } from '../DispatchCalendar/useTripMenuActions';
import { dispatcherSlice } from '../dispatcher.slice';
import { MultiloadOrderStep } from './MultiloadOrderStep';
import { MultiloadSelectionStep } from './MultiloadSelectionStep';

export function MultiloadAssignmentFlow() {
  const dispatch = useAppDispatch();
  const unassignedTrips = useAppSelector(
    (state) => state.dispatcher.dispatchResponse?.unassigned_trips
  );
  const assignedTrips = useAppSelector(
    (state) => state.dispatcher.dispatchResponse?.assigned_trips
  );
  const {
    isMultiloadAssignmentFlowOpen,
    selectedTripIdsToMultiload,
    originatingTripId,
    assignmentIdToMultiload,
    multiLoadId,
    mode,
  } = useAppSelector((state) => state.dispatcher.multiloadAssignmentFlow);
  const tripMenuActions = useTripMenuActions();

  const onNext = (next: () => void) => {
    if (selectedTripIdsToMultiload.length > 1) return next();

    const cancelFlow = () =>
      dispatch(dispatcherSlice.actions.onMultiloadFlowCancel());

    const unassignedTrip = unassignedTrips?.find(
      (trip) => trip.id === originatingTripId
    );
    if (unassignedTrip) {
      cancelFlow();
      tripMenuActions.assign(
        originatingTripId,
        assignmentIdToMultiload,
        unassignedTrip.status
      );
      return;
    }

    if (mode === 'edit-trip-multi-load' && multiLoadId) {
      tripMenuActions.removeMultiLoad(multiLoadId);
      cancelFlow();
      return;
    }

    const assignedTrip = assignedTrips?.find(
      (trip) => trip.id === originatingTripId
    );
    if (assignedTrip) {
      cancelFlow();
      tripMenuActions.reassign(
        originatingTripId,
        assignmentIdToMultiload,
        assignedTrip.status,
        assignedTrip.multiload_id
      );
      return;
    }
  };

  return (
    <Modal
      open={isMultiloadAssignmentFlowOpen}
      onClose={() => {
        dispatch(dispatcherSlice.actions.onMultiloadFlowCancel());
      }}
      setOpen={() => {}}
      title="Multi-Load Assignment"
    >
      <ProgressBarWizard
        steps={[
          {
            title: 'Multi-Load Selection',
            render: ({ next }) => (
              <MultiloadSelectionStep onNext={() => onNext(next)} />
            ),
          },
          {
            title: 'Multi-Load Order',
            render: () => <MultiloadOrderStep />,
          },
        ]}
      />
    </Modal>
  );
}
